import React from "react"
import Img from "gatsby-image"
import { Link } from "gatsby"
import WavyLink from "../fragments/wavy-link"

import styled from "@emotion/styled"

const RelatedProjectContainer = styled.section`
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: repeat(12, 1fr);
  gap: 2rem;
  padding: 5rem 0;
  position: relative;
  max-width: 72rem;

  @media (min-width: 46rem) {
    gap: 1rem;
    padding: 7rem 3rem;

    p {
    }

    &:hover {
      .rp-img {
        .gatsby-image-wrapper {
          transition: transform 0.44s cubic-bezier(0.6, 0.04, 0.98, 0.335);
          transform: translateX(1rem);
        }
      }
    }
  }
`
const RPContent = styled.div`
  align-self: center;
  grid-column-end: span 7;

  @media (min-width: 46rem) {
    grid-column-end: span 5;
    grid-column-start: 8;
  }
`

const RPIntro = styled.p`
  margin: 0 0 1rem;
  color: ${props => props.theme.grays.mid};
  font-size: 0.87rem;
`

const RPTitle = styled.h4`
  font-size: 1.75rem;
  margin: 0 0 1rem;

  @media (min-width: 46rem) {
    font-size: 3rem;
    margin: 0;
  }
`

const RPType = styled.p`
  margin-bottom: 1rem;

  @media (max-width: 46rem) {
    display: none;
  }
`

const RPImage = styled.div`
  grid-column-end: span 5;

  .gatsby-image-wrapper {
    height: 15rem;
  }

  @media (min-width: 46rem) {
    grid-column-end: span 6;

    .gatsby-image-wrapper {
      width: 100%;
      height: auto;
      overflow: hidden;
      transition: transform 0.22s cubic-bezier(0.165, 0.84, 0.44, 1);
      transform: translateX(0rem);
      will-change: transform;
    }
  }
`

function RelatedProject(props) {
  const related = props.data[0]

  return (
    <RelatedProjectContainer>
      <RPImage className="rp-img">
        <Link to={`/work/${related.slug}`} title={related.title}>
          <Img
            fluid={related.imageFile[0].childImageSharp.fluid}
            alt={related.title}
            title={related.title}
          />
        </Link>
      </RPImage>
      <RPContent>
        <RPIntro>Another Project?</RPIntro>
        <RPTitle>{related.title}</RPTitle>
        <RPType>{related.projectType}</RPType>
        <WavyLink
          href={`/work/${related.slug}`}
          title={related.title}
          text="View Project 🡒"
          textColor="blackText"
          lineColor="blueLine yellowLineHover"
        />
      </RPContent>
    </RelatedProjectContainer>
  )
}

export default RelatedProject
